import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { PartnerHero } from "@/components/partner/PartnerHero";
import { WhyPartner } from "@/components/partner/WhyPartner";
import { PartnerVision } from "@/components/partner/PartnerVision";
import { Roadmap } from "@/components/partner/Roadmap";
import { UniversityDashboard } from "@/components/partner/UniversityDashboard";
import { Compliance } from "@/components/partner/Compliance";
import { EnquiryForm } from "@/components/partner/EnquiryForm";
import { Seo, breadcrumb, SITE } from "@/components/site/Seo";

export default function Partner() {
  return (
    <div className="App min-h-screen bg-white" data-testid="partner-page">
      <Seo
        title="Partner with OpenDegree — For Education Providers"
        description="Partner with OpenDegree to identify, engage and enrol suitable learners through an efficient, transparent and largely automated admissions and recruitment platform."
        path="/partner"
        jsonLd={breadcrumb([{ name: "Home", path: "/" }, { name: "Partner", path: "/partner" }])}
      />
      <Navbar />
      <main>
        <PartnerHero />
        <WhyPartner />
        <PartnerVision />
        <Roadmap />
        <UniversityDashboard />
        <Compliance />
        <EnquiryForm />
      </main>
      <Footer />
    </div>
  );
}
